/**
 * Format ISO8601 date string to long format (e.g., "March 15, 2025")
 * @param dateString ISO8601 date string (YYYY-MM-DD)
 * @returns Formatted date string or 'N/A' if invalid
 */
export function formatEffectiveDate(dateString: string | null | undefined): string {
  if (!dateString) return 'N/A'

  const date = new Date(Date.parse(dateString))

  if (Number.isNaN(date.getTime())) {
    return 'N/A'
  }

  // Display in UTC to match how ISO8601 date-only strings are parsed
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'UTC',
  })
}
